import { Link } from "react-router-dom";

export default function Forbidden() {
  return (
    <main className="min-h-screen grid place-items-center p-8">
      <div className="max-w-md w-full text-center">
        <h1 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl mb-2">Not authorized</h1>
        <p className="text-muted-foreground mb-6">
          Your account doesn't have access. Contact your administrator if this is a mistake.
        </p>
        <Link to="/signin" className="text-primary underline">
          Back to sign in
        </Link>
      </div>
    </main>
  );
}
